"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "villamassargia": {
    "e0f0f3db": [{
      "hkey": "e64612d8",
      "slug": "villamassargia",
      "name": "Villamassargia",
      "primary": true,
      "skipSearch": false
    }],
    "arriali": [{
      "hkey": "e64612d8",
      "slug": "villamassargia",
      "name": "Villamassargia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "31df6fa3": [{
      "hkey": "e64612d8",
      "slug": "villamassargia",
      "name": "Villamassargia",
      "primary": true,
      "skipSearch": false
    }],
    "astia": [{
      "hkey": "e64612d8",
      "slug": "villamassargia",
      "name": "Villamassargia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f9610d00": [{
      "hkey": "e64612d8",
      "slug": "villamassargia",
      "name": "Villamassargia",
      "primary": true,
      "skipSearch": false
    }],
    "caput-acquas": [{
      "hkey": "e64612d8",
      "slug": "villamassargia",
      "name": "Villamassargia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b8180c8a": [{
      "hkey": "e64612d8",
      "slug": "villamassargia",
      "name": "Villamassargia",
      "primary": true,
      "skipSearch": false
    }],
    "monte-cadelano": [{
      "hkey": "e64612d8",
      "slug": "villamassargia",
      "name": "Villamassargia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c85f6e87": [{
      "hkey": "e64612d8",
      "slug": "villamassargia",
      "name": "Villamassargia",
      "primary": true,
      "skipSearch": false
    }],
    "monte-gioiosa-guardia": [{
      "hkey": "e64612d8",
      "slug": "villamassargia",
      "name": "Villamassargia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "bb7a1d1a": [{
      "hkey": "e64612d8",
      "slug": "villamassargia",
      "name": "Villamassargia",
      "primary": true,
      "skipSearch": false
    }],
    "s-ortu-mannu": [{
      "hkey": "e64612d8",
      "slug": "villamassargia",
      "name": "Villamassargia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f8787e45": [{
      "hkey": "e64612d8",
      "slug": "villamassargia",
      "name": "Villamassargia",
      "primary": true,
      "skipSearch": false
    }],
    "tallaroga": [{
      "hkey": "e64612d8",
      "slug": "villamassargia",
      "name": "Villamassargia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "55e0b9d0": [{
      "hkey": "e64612d8",
      "slug": "villamassargia",
      "name": "Villamassargia",
      "primary": true,
      "skipSearch": false
    }],
    "tuerra-manna": [{
      "hkey": "e64612d8",
      "slug": "villamassargia",
      "name": "Villamassargia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;